var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"side-pic"},[_c('div',{staticClass:"side-user-head-portrait"}),_c('div',{staticClass:"side-username"},[_c('h3',{staticClass:"side-user-id",style:(_vm.color)},[_vm._v(_vm._s(_vm.userInfo.nickName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }